import React from "react";
import { Text } from "@puzzle/ui";
import { styled } from "@puzzle/theme";

const Container = styled("div", {
  margin: "$2",
  display: "flex",
  flexDirection: "column",
  gap: "$2",
  alignItems: "center",
  textAlign: "center",
  textVariant: "$body",
  color: "$text-neutral-base",
});

const StyledLink = styled("a", {
  color: "$text-neutral-base",
});

export const NoDataMessage = () => {
  return (
    <Container>
      <Text color="$text-neutral-subdue">No results found.</Text>
      <Text>
        Puzzle supports direct payroll integrations that will automatically create journal entries
        and payroll summaries for these payroll providers, which will display on this page.
      </Text>
    </Container>
  );
};
